/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableColumnsType } from "antd";
import CustomRangePicker from "@component/CustomRangePicker";
import CustomTable from "@component/CustomTable";
import IconTitle from "@icon/IconTitle";
import CustomButton from "@component/CustomButton";
import {
  DashboardDetailItem,
  DashboardDetailParam,
  DashboardDetailSearchConditions,
} from "@interface/dashboard/Dashboard";
import { Option } from "antd/lib/mentions";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import CustomValidFormSelect from "@component/form/CustomValidFormSelect";
import CustomValidFormInput from "@component/form/CustomValidFormInput";
import CustomValidFormCheckbox from "@component/form/CustomValidFormCheckbox";
import IconBtnSearch from "@icon/IconBtnSearch";
import {
  getDashboardDetail,
  getDashboardDetailSearchConditions,
} from "@api/DashboardApi";
import { HttpStatusCode } from "axios";
import { message } from "antd";
import { DASHBOARD_DETAIL_HEADER } from "@util/constants";
import ExcelJS from "exceljs";
import CustomModal from "@component/CustomModal";
const IMAGE_PATH = "http://safeiot.eseoul.go.kr/images/";
const DashboardDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const sensorType = location?.state?.sensorType==="battery"?["battery1","battery2","battery3"]:location?.state?.sensorType==="thermometerHalf"?["temp","hum"]:location?.state?.sensorType;
  const ntnlPntNo = location?.state?.ntnlPntNo;
  const sggValue = location?.state?.sggValue;
  const {
    control: searchFormControl,
    handleSubmit: searchFormHandleSubmit,
    setValue,
    getValues,
    watch,
  } = useForm<DashboardDetailParam>({ mode: "all" });
  const watchStartDate = watch("startDate");
  const watchEndDate = watch("endDate");
  const [dashboardDetailList, setDashboardDetailList] = useState<
    DashboardDetailItem[]
  >([]);

  const [listLoading, setListLoading] = useState(false);
  const [sensor, setSensor] = useState(true);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImg, setModalImg] = useState<any>();
  const [
    dashboardDetailSearchConditionsState,
    setDashboardDetailSearchConditionsState,
  ] = useState<DashboardDetailSearchConditions>({
    sggList: [],
  });

  const downloadExcel = async (type: string) => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Sheet 1");
    const excelData = [
      { data: ["[검색조건]"] },
      { data: ["기간", getValues("startDate"), getValues("endDate")] },
      {
        data: [
          "권역",
          getValues("sggCd") === ""
            ? "전체"
            : dashboardDetailSearchConditionsState.sggList.filter(
                (item) => item.value === getValues("sggCd")
              )[0].label,
        ],
      },
      { data: ["국가지점/다목적위치표지판 번호", getValues("lctnSignNo")] },
      { data: [""] },
      { data: DASHBOARD_DETAIL_HEADER },
    ];

    excelData.forEach((item, index) => {
      sheet.getRow(index + 1).values = [...item.data];
    });
    sheet.getRow(6).eachCell((cell: ExcelJS.Cell) => {
      cell.style.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
    });
    dashboardDetailList.forEach((item: any, index) => {
      sheet.getRow(index + 7).values = [
        item.dateTime,
        item.accdntAreaFlag ? "O" : "X",
        item.ntnlPntNo,
        item.lctnSignNo,
        item.battery1,
        item.battery2,
        item.battery3,
        item.batteryChCnt,
        item.temp,
        item.hum,
        item.gpsLon,
        item.gpsLat,
        item.slope,
        item.shock,
        item.sound,
      ];
      sheet.getRow(index + 7).eachCell((cell: ExcelJS.Cell) => {
        cell.style.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
      });
    });

    sheet.columns.forEach((column, index) => {
      const header = sheet
        .getRow(6)
        .getCell(index + 1)
        .value?.toString();
      if (index === 0) {
        column.width = 30;
      } else {
        column.width = header ? header.length + 10 : 12;
      }
    });

    let buffer;
    if (type === "01") {
      buffer = await workbook.csv.writeBuffer();
    } else {
      buffer = await workbook.xlsx.writeBuffer();
    }

    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = type === "01" ? "대시보드상세.csv" : "대시보드상세.xlsx";
    anchor.click();
    window.URL.revokeObjectURL(url);
  };
  const dashboardDetailColumns: TableColumnsType<DashboardDetailItem> = [
    {
      title: "사고다발지역",
      dataIndex: "accdntAreaFlag",
      key: "accdntAreaFlag",
      width: 100,
      align: "center",
      render: (value) => {
        return value ? "◎" : "";
      },
    },
    {
      title: "국가지점번호",
      dataIndex: "ntnlPntNo",
      key: "ntnlPntNo",
      width: 110,
      align: "center",
      render: (value: string) => {
        return value;
      },
    },
    {
      title: "다목적위치표지판번호",
      dataIndex: "lctnSignNo",
      key: "lctnSignNo",
      width: 150,
      align: "center",
    },
    {
      title: "센서설치현황",
      width: 100,
      align: "center",
      render: (record: any) => {
        const imgSrc = IMAGE_PATH + record.ntnlPntNo + '.jpg'; //추후에는 이 소스 사용하시면 됩니다.
        //const imgSrc = IMAGE_PATH + "logo192.png";
        return (
          <>
            <img
              src={imgSrc}
              loading="lazy"
              decoding="async"
              width={90}
              height={60}
              style={{
                width: 90,
                height: "60px",
                objectFit: "cover",
                backgroundColor: "#f0f0f0",
                cursor: "pointer",
              }}
              onError={(e) => {
                e.currentTarget.style.visibility = "hidden";
              }}
              onClick={() => {
                setModalImg(imgSrc);
                setModalOpen(!modalOpen);
              }}
            />
          </>
        );
      },
    },
    {
      title: "일자",
      dataIndex: "dateTime",
      key: "dateTime",
      width: 110,
      align: "center",
      render: (value) => {
        if (value) return dayjs(value).format("YYYY-MM-DD");
      },
    },
    {
      title: "시간",
      dataIndex: "dateTime",
      key: "dateTime",
      width: 80,
      align: "center",
      render: (value) => {
        if (value) return dayjs(value).format("HH:mm");
      },
    },
    {
      title: "배터리1",
      dataIndex: "battery1",
      key: "battery1",
      width: 80,
      align: "center",
      render: (value, record: any) => {
        if (value > record.battery1AlarmLevel) {
          return <p>{value}</p>;
        } else {
          return <p style={{ color: "red" }}>{value}</p>;
        }
      },
    },
    {
      title: "배터리2",
      dataIndex: "battery2",
      key: "battery2",
      width: 80,
      align: "center",
      render: (value, record: any) => {
        if (value > record.battery2AlarmLevel) {
          return <p>{value}</p>;
        } else {
          return <p style={{ color: "red" }}>{value}</p>;
        }
      },
    },
    {
      title: "배터리3",
      dataIndex: "battery3",
      key: "battery3",
      width: 80,
      align: "center",
      render: (value, record: any) => {
        if (value > record.battery3AlarmLevel) {
          return <p>{value}</p>;
        } else {
          return <p style={{ color: "red" }}>{value}</p>;
        }
      },
    },
    {
      title: "배터리 교체횟수",
      dataIndex: "batteryChCnt",
      key: "batteryChCnt",
      width: 80,
      align: "center",
    },
    {
      title: "온도",
      dataIndex: "temp",
      key: "temp",
      width: 80,
      align: "center",
      render: (value, record: any) => {
        if (value) {
          const levelArr =
            record.tempAlarmLevel && record.tempAlarmLevel.split(":");
          if (levelArr && levelArr[0] > value && levelArr[1] < value) {
            return <p>{value}</p>;
          } else {
            return <p style={{ color: "red" }}>{value}</p>;
          }
        } else {
          return "";
        }
      },
    },
    {
      title: "습도",
      dataIndex: "hum",
      key: "hum",
      width: 80,
      align: "center",
      render: (value, record: any) => {
        if (value) {
          const levelArr =
            record.humAlarmLevel && record.humAlarmLevel.split(":");
          if (levelArr && levelArr[0] > value && levelArr[1] < value) {
            return <p>{value}</p>;
          } else {
            return <p style={{ color: "red" }}>{value}</p>;
          }
        } else {
          return "";
        }
      },
    },
    {
      title: "GNSS-경도",
      dataIndex: "gpsLon",
      key: "gpsLon",
      width: 100,
      align: "center",
      render: (value, record: any) => {
        const gpsLon = value ? value : "";
        if (gpsLon) {
          const gpsAlarmMax = record.gpsLonAlarmLevel + record.gpsLonRefValue;
          const gpsAlarmMin = record.gpsLonAlarmLevel - record.gpsLonRefValue;
          const flag = gpsLon > gpsAlarmMin && gpsLon < gpsAlarmMax;
          return <p style={{ color: flag ? "red" : "" }}>{gpsLon}</p>;
        }
        return "";
      },
    },
    {
      title: "GNSS-위도",
      dataIndex: "gpsLat",
      key: "gpsLat",
      width: 100,
      align: "center",
      render: (value, record: any) => {
        const gpsLat = value ? value : "";
        if (gpsLat) {
          const gpsAlarmMax = record.gpsLatAlarmLevel + record.gpsLatRefValue;
          const gpsAlarmMin = record.gpsLatAlarmLevel - record.gpsLatRefValue;
          const flag = gpsLat > gpsAlarmMin && gpsLat < gpsAlarmMax;
          return <p style={{ color: flag ? "red" : "" }}>{gpsLat}</p>;
        }
        return "";
      },
    },
    {
      title: "기울기",
      dataIndex: "slope",
      key: "slope",
      width: 100,
      align: "center",
      render: (value, record: any) => {
        if (value) {
          const valueArr = value && value.split(":");
          const levelArr =
            record.slopeAlarmLevel && record.slopeAlarmLevel.split(":");
          if (
            levelArr &&
            valueArr &&
            (levelArr[0] < valueArr[0] ||
              -levelArr[0] > valueArr[0] ||
              levelArr[1] < valueArr[1] ||
              -levelArr[1] > valueArr[1] ||
              levelArr[2] < valueArr[2]||
              -levelArr[2] > valueArr[2])
          ) {
            return <p style={{ color: "red" }}>{value}</p>;
          } else {
            return value;
          }
        } else {
          return "";
        }
      },
    },
    {
      title: "충격",
      dataIndex: "shock",
      key: "shock",
      width: 80,
      align: "center",
      render: (value, record: any) => {
        if (value > record.shockAlarmLevel) {
          return <p style={{ color: "red" }}>{value}</p>;
        } else {
          return <p>{value}</p>;
        }
      },
    },
    {
      title: "데시벨",
      dataIndex: "sound",
      key: "sound",
      width: 80,
      align: "center",
      render: (value, record: any) => {
        if (value > record.soundAlarmLevel) {
          return <p style={{ color: "red" }}>{value}</p>;
        } else {
          return <p>{value}</p>;
        }
      },
    },
    // {
    //   title: "데시벨 초과횟수",
    //   dataIndex: "soundOverCnt",
    //   key: "soundOverCnt",
    //   width: 80,
    //   align: "center",
    //   render: (value, record: any) => {
    //     if (!record.sound) {
    //       return "0회";
    //     } else {
    //       if (record.sound > record.soundAlarmLevel) {
    //         return "1회";
    //       } else {
    //         return "0회";
    //       }
    //     }
    //   },
    // },
    // {
    //   title: '비상스위치(on/off)',
    //   dataIndex: 'swithFlag',
    //   key: 'swithFlag',
    //   align: 'center',
    //   render: (value) => {
    //     return value ? 'ON' : 'OFF';
    //   },
    // },
    // {
    //   title: '스위치 눌린 횟수',
    //   dataIndex: 'switchCnt',
    //   key: 'switchCnt',
    //   align: 'center',
    // },
  ];

  const dataSearch = (data: DashboardDetailParam) => {
    setListLoading(true);
    getDashboardDetail(data)
      .then((res) => {
        if (res.code === HttpStatusCode.Ok && res.item) {
          setDashboardDetailList(res.item);
        }
      })
      .finally(() => {
        setListLoading(false);
      });
  };

  const dashboardDetailSearchConditions = () => {
    //검색조건 조회시 추후 센서 종류도 공통코드로 관리 들어가야 할것으로 보임.
    getDashboardDetailSearchConditions().then((res) => {
      if (res.code === HttpStatusCode.Ok && res.item) {
        setDashboardDetailSearchConditionsState(res.item);
        initSearchParam({
          sensorType: sensorType,
          ntnlPntNo: ntnlPntNo,
          sggValue: sggValue,
        });

        const dateParam = {
          startDate: "",
          endDate: "",
        };

        if (sensorType) {
          setSensor(false);
          dateParam.startDate = dayjs().format("YYYY-MM-DD");
          dateParam.endDate = dayjs().format("YYYY-MM-DD");
        } else {
          dateParam.startDate = dayjs()
            .subtract(1, "month")
            .format("YYYY-MM-DD");
          dateParam.endDate = dayjs().format("YYYY-MM-DD");
        }

        setValue("startDate", dateParam.startDate);
        setValue("endDate", dateParam.endDate);

        dataSearch({
          startDate: dateParam.startDate,
          endDate: dateParam.endDate,
          sggCd: "",
          senSorStatus: sensorType ? "false" : "",
          lctnSignNo: ntnlPntNo,
          sensorType: sensorType,
          accdntAreaFlag: null,
        });
      }
    });
  };

  const initSearchParam = (param: {
    sensorType: string|null;
    ntnlPntNo: string;
    sggValue: string;
  }) => {
    const today = dayjs();

    let startDate = "";
    if (param.sensorType) {
      setValue("sensorType", param.sensorType);
    } else {
      if (ntnlPntNo) {
        startDate = today.subtract(1, "month").format("YYYY-MM-DD");
      }
    }
    setValue("startDate", startDate);
    setValue("endDate", "");
    setValue("accdntAreaFlag", null);
    setValue("sggCd", sggValue ? sggValue : "");
    setValue("senSorStatus", param.sensorType ? "false" : "");
    setValue("lctnSignNo", param.ntnlPntNo);
  };

  useEffect(() => {
    dashboardDetailSearchConditions();
  }, [ntnlPntNo]);

  return (
    <>
      <CustomModal
        open={modalOpen}
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={() => setModalOpen(false)}
      >
        <img src={modalImg} style={{ width: "100%", height: "100%" }} />
      </CustomModal>
      <section className="title-wrap">
        <div className="box-flex">
          <h2 className="title">대시보드 상세</h2>
        </div>
        <section className="button-wrap">
          <div className="box-btn">
            <CustomButton
              type="primary"
              onClick={searchFormHandleSubmit(dataSearch)}
            >
              <IconBtnSearch />
              조회
            </CustomButton>
          </div>
        </section>
      </section>
      <section className="search-wrap">
        <form>
          <div className="deps">
            <span>기간</span>
            <CustomRangePicker
              open={open}
              onOpenChange={(open) => setOpen(open)}
              value={[
                watchStartDate ? dayjs(watchStartDate) : null,
                watchEndDate ? dayjs(watchEndDate) : null,
              ]}
              minLength={6}
              onChange={(value) => {
                if (!value || !value[0] || !value[1]) {
                  setValue("startDate", "");
                  setValue("endDate", "");
                  return;
                }
                const maxDate = dayjs().subtract(6, "month");
                if (value[0].isBefore(maxDate) || value[1].isBefore(maxDate)) {
                  message.error("최대 6개월까지만 조회 가능합니다.");
                  setOpen(false);
                  return;
                }
                setValue("startDate", value[0].format("YYYY-MM-DD"));
                setValue("endDate", value[1].format("YYYY-MM-DD"));
              }}
            />

            <span>권역</span>
            <CustomValidFormSelect control={searchFormControl} name={"sggCd"}>
              <Option value={""}>전체</Option>
              {dashboardDetailSearchConditionsState.sggList.map(
                (item, index) => {
                  return (
                    <Option key={`sgg_${index}`} value={item.value}>
                      {item.label}
                    </Option>
                  );
                }
              )}
            </CustomValidFormSelect>

            <span>국가지점/다목적위치표지판 번호</span>
            <CustomValidFormInput
              name={"lctnSignNo"}
              control={searchFormControl}
            />
          </div>

          <div className="deps">
            <span>센서 상태</span>
            <CustomValidFormSelect
              control={searchFormControl}
              name={"senSorStatus"}
              onChangeValueback={(v)=>{
                if(v!="false")
                {setSensor(true);
                setValue("sensorType",null);}
                else
                {setSensor(false);}

              }}
            >
              <Option value={""}>전체</Option>
              <Option value={"true"}>정상</Option>
              <Option value={"false"}>비정상</Option>
            </CustomValidFormSelect>

            <span>센서 종류</span>
            <CustomValidFormSelect
              control={searchFormControl}
              name={"sensorType"}
              disabled={sensor}
              mode="multiple"
            >
              <Option value={"temp"}>온도</Option>
              <Option value={"hum"}>습도</Option>
              <Option value={"gps"}>GNSS</Option>
              <Option value={"slope"}>기울기</Option>
              <Option value={"shock"}>충격</Option>
              <Option value={"sound"}>소리</Option>
              <Option value={"battery1"}>배터리1</Option>
              <Option value={"battery2"}>배터리2</Option>
              <Option value={"battery3"}>배터리3</Option>
            </CustomValidFormSelect>

            <CustomValidFormCheckbox
              control={searchFormControl}
              name={"accdntAreaFlag"}
            />
            <span>사고다발지역</span>
          </div>
        </form>
      </section>
      <section className="board-wrap">
        <div>
          <div className="board-title-wrap">
            <h3 className="title">
              <IconTitle />
              목록
            </h3>
            <div className="box-btn">
              <CustomButton
                type="default"
                size="small"
                onClick={() => downloadExcel("01")}
              >
                CSV
              </CustomButton>
              <CustomButton
                type="default"
                size="small"
                onClick={() => downloadExcel("02")}
              >
                EXCEL
              </CustomButton>
            </div>
          </div>
          <div className="board-cont-wrap">
            <CustomTable
              className="table-type-inp"
              columns={dashboardDetailColumns}
              rowKey={"id"}
              dataSource={dashboardDetailList}
              rowNoFlag={true}
              loading={listLoading}
              virtual
              scroll={{ x: 1635 }}
              onRow={(record) => {
                return {
                  onDoubleClick: () => {
                    navigate("/sensor-statistics", { state: { record } });
                  },
                };
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
};
export default DashboardDetail;
